module.exports = __webpack_public_path__ + "static/media/footer-rsvp.a2927c21.jpg";